export default __webpack_public_path__ + "static/media/single-project-page-03-img09.d0dd53e8.jpg";